import { graphql } from "~/gql";

export const CREATE_FILE_DATA_IMPORT = graphql(/* GraphQL */ `
  mutation createFileDataImport($upload: Upload!, $type: VpdDataImportType!) {
    createFileDataImport(upload: $upload, type: $type) {
      dataFrameResults {
        succeeded
        message
        details {
          type
          rowNumber
          messages
        }
      }
    }
  }
`);
